import ExternalRedirect from './ExternalRedirect';

export default ExternalRedirect;
